<template>
    <transition name="fade" appear>
        <div
            tabindex="-1"
            class="custom-modal animate-in"
            :class="[size]"
        >
            <div
                @click="close"
                class="custom-modal-bg"
            />

            <div class="custom-modal-box">
                <div
                    v-if="$slots.header || title"
                    class="custom-modal-box-header"
                >
                    <slot name="pre-header" />

                    <h2
                        v-if="title"
                        class="custom-modal-title mb-0"
                    >
                        {{ title }}
                    </h2>

                    <button
                        v-if="closable"
                        @click="close"
                        aria-label="Sluiten"
                        class="custom-modal-close"
                    >
                        <ui-icon icon="close" />
                    </button>

                    <slot name="header" />

                </div>

                <div class="custom-modal-box-content">
                    <slot />
                </div>

                <div
                    v-if="$slots.footer"
                    class="custom-modal-box-footer"
                >
                    <slot name="footer"/>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import { mapMutations } from 'vuex';

    import UiIcon from './icon.vue';

    export default {
        name: 'Modal',
        components: {
            UiIcon,
        },
        data() {
            return {
                mainContent: document.querySelector('.app-content'),
            };
        },
        props: {
            title: {
                type: String,
                default: null,
            },
            closable: {
                type: Boolean,
                default: true,
            },
            size: {
                type: String,
                default: 'medium',
            },
        },
        async mounted() {
            await this.$nextTick();

            this.mainContent.style.top = -window.pageYOffset + 'px';
            document.body.classList.add('custom-modal-open');

            document.addEventListener('keyup', (e) => {
                if (e.key === 'Escape') this.close();
            });
        },
        destroyed() {
            const scrollOffset = Math.abs(parseFloat(this.mainContent.style.top));

            document.body.classList.remove('custom-modal-open');
            this.mainContent.style.removeProperty('top');
            window.scrollTo(0, scrollOffset);
            document.removeEventListener('keyup', this.close);
        },
        methods: {
            ...mapMutations('modal', [
                'setModal',
            ]),

            async close() {
                if (!this.closable) return;

                await this.confirmModal();

                this.setModal(null);
                this.$emit('close');
            },
        },
    };
</script>

<style lang="scss">
    .custom-modal {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        z-index: 103;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        min-height: 100vh;

        &-open .app-content {
            position: fixed;
            display: flex;
            width: 100%;
        }

        &-bg {
            position: fixed;
            top: 0;
            left: 0;
            z-index: 1;
            width: 100%;
            height: 100%;
            background-color: rgba($dark, 0.7);
        }

        &-box {
            position: relative;
            z-index: 2;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            width: 100%;
            background-color: #fff;
            box-shadow: 1px 1px 2px rgba(#000, 0.05);

            @include respond-to(lg) {
                flex-grow: 0;
                max-width: 600px;
                margin: 32px auto;
            }

            .modal-small & {
                width: 480px;
            }

            &-header {
                position: relative;
                padding: 16px 44px 16px 16px;
                border-bottom: 1px solid $info;

                @include respond-to(lg) {
                    padding: 24px 46px 24px 32px;
                }
            }

            &-content {
                display: flex;
                flex: 1 1 auto;
                align-items: center;
                padding: 16px;

                @include respond-to(lg) {
                    padding: 32px;
                }

                > * {
                    flex: 1 1 auto;
                }
            }

            &-footer {
                padding: 16px;
                background: $info;
                border-radius: 0 0 5px 5px;

                @include respond-to(lg) {
                    padding: 32px;
                }
            }
        }

        &-close {
            position: absolute;
            top: 8px;
            right: 8px;
            z-index: 3;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 48px;
            height: 48px;
            font-size: 32px;
            line-height: 48px;
            color: $dark;
            text-align: center;
            transition: color 0.3s;

            &:hover {
                color: $primary;
            }

            @include respond-to(lg) {
                top: 16px;
                right: 16px;
            }
        }
    }
</style>
